import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import highlightingService from 'services/highlightingService';

import { BarGraph } from 'frontend-component-library';

class TagBarGraph extends PureComponent {
  constructor(props) {
    super(props);

    this.isHighlighted = false;
  }

  startHighlighting = () => {
    if (this.isHighlighted) return;
    const { tag } = this.props;
    this.isHighlighted = true;
    highlightingService.highlightTag(tag);
  };

  stopHighlighting = event => {
    this.isHighlighted = false;
    highlightingService.resetHighlighting(event);
  };

  handleTouch = event => {
    event.stopPropagation();
    this.startHighlighting();
  };

  getClassName = () => {
    return `TagBarGraph ${this.props.tag.short_name}`;
  };

  render() {
    const { tag, percentage } = this.props;

    return (
      <BarGraph
        data-id={tag.id}
        className={this.getClassName()}
        title={tag.name}
        percentage={Math.round(percentage)}
        onClick={this.handleClick}
        onMouseEnter={this.startHighlighting}
        onMouseLeave={this.stopHighlighting}
      />
    );
  }
}

TagBarGraph.propTypes = {
  tag: PropTypes.object.isRequired,
  percentage: PropTypes.number.isRequired,
};

export default TagBarGraph;



// WEBPACK FOOTER //
// ./src/Components/Pages/Results/RankedLists/TagBarGraph.js